<mat-sidenav-container (backdropClick)="closeMenu()" class="sidenav-container">

<mat-sidenav [ngClass]="routeAnimationsElements" class="sidenav" [mode]="isMobileMode ? 'side' : 'side'"
    [fixedInViewport]="isMobileMode" fixedTopGap="56" [opened]="showMenu" class="mainmenuadjust">
    <mat-nav-list>
      <button mat-menu-item class="sidenav-btn" [class.sidenav-active-link]="currentRoute === '/home'"(click)="clickSidenavItem('/home')" [routerLink]="['/']">
        <mat-icon>home</mat-icon> Home
      </button>
      <mat-expansion-panel [expanded]="isTrackingExpanded" (opened)="expandPanel('tracking')" (closed)="collapsePanel('tracking')">
        <mat-expansion-panel-header>
          <button mat-menu-item class="sidenav-btn"
            (click)="clickSidenavItem(hasCustomerAdminRole ? '/my-tours': '/dashboard')"
            [routerLink]="[hasCustomerAdminRole ? '/my-tours': '/dashboard']">
            <mat-icon>share_location</mat-icon> Tracking
          </button>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent let-route let-last="last" ngFor [ngForOf]="sidenavRoutes">
          <button *ngIf="route?.data?.showExpansion === true" mat-menu-item class="sidenav-btn"
            [class.sidenav-active-link]="(route?.data?.url === currentRoute && clickItem==='') || route?.data?.url === clickItem"
            (click)="clickSidenavItem(route?.data?.url)"
            [routerLink]="[route?.data?.url]">
            <div style="padding-left: 20px;">
              <mat-icon class="sidenav-icon">{{route?.data?.icon}}</mat-icon>
              {{route?.data?.title}}
            </div>
          </button>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="hasControlTowerRole && !hasCustomerAdminRole"
        [expanded]="isControlTowerExpanded"
        (opened)="expandPanel('controlTower')"
        (closed)="collapsePanel('controlTower')">
        <mat-expansion-panel-header>
          <button mat-menu-item class="sidenav-btn"
            (click)="clickSidenavItem('/control-tower-dashboard')"
            [routerLink]="['/control-tower-dashboard']">
            <mat-icon>cell_tower</mat-icon> Control Tower
          </button>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent let-route let-last="last" ngFor [ngForOf]="sidenavRoutes">
          <button *ngIf="route?.data?.controlTowerItem === true" mat-menu-item class="sidenav-btn"
            [class.sidenav-active-link]="(route?.data?.url === currentRoute && clickItem === '') || route?.data?.url === clickItem"
            (click)="clickSidenavItem(route?.data?.url)"
            [routerLink]="[route?.data?.url]">
            <div style="padding-left: 20px;">
              <mat-icon class="sidenav-icon">{{route?.data?.icon}}</mat-icon>
              {{route?.data?.title}}
            </div>
          </button>
        </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="hasCustomsRole || hasCustomerAdminRole"
        [expanded]="isCustoms"
        (opened)="expandPanel('customs')"
        (closed)="collapsePanel('customs')">
        <mat-expansion-panel-header>
          <button mat-menu-item class="sidenav-btn"
            (click)="clickSidenavItem(hasCustomsRole ? '/customs-dashboard' : '/customs-listing')"
            [routerLink]="[hasCustomsRole ? '/customs-dashboard' : '/customs-listing']">
            <mat-icon>support_agent</mat-icon> Customs
          </button>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent let-route let-last="last" ngFor [ngForOf]="sidenavRoutes">
          <button *ngIf="route?.data?.customsItem === true" mat-menu-item class="sidenav-btn"
            [class.sidenav-active-link]="(route?.data?.url === currentRoute && clickItem === '') || route?.data?.url === clickItem"
            (click)="clickSidenavItem(route?.data?.url)"
            [routerLink]="[route?.data?.url]">
            <div style="padding-left: 20px;">
              <mat-icon class="sidenav-icon">{{route?.data?.icon}}</mat-icon>
              {{route?.data?.title}}
            </div>
          </button>
        </ng-template>
    </mat-expansion-panel>

      <mat-menu>
      </mat-menu>
      <ng-template let-route let-last="last" ngFor [ngForOf]="sidenavRoutes">
        <button *ngIf="route?.data?.showExpansion === false && route?.data?.controlTowerItem === false && route?.data?.customsItem === false" mat-menu-item class="sidenav-btn"
          [class.sidenav-active-link]="route.data.url === currentRoute" (click)="clickSidenavItem(route.data.url)"
          [routerLink]="[route.data.url]">
          <mat-icon>{{route.data.icon}}</mat-icon> {{route.data.title}}
        </button>
      </ng-template>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <div fxFlexFill fxLayout="column" [@routeAnimations]="o.isActivated && o.activatedRoute.url">
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
